export default [
    {
        name: 'agencyList',
        path: '/agency/list',
        component: require('@/pages/AgencyList').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'agency' })
        }
    },
    {
        name: 'agencyCreate',
        path: '/agency/create',
        component: require('@/pages/AgencyCreate').default,
        meta: {
            back: { label: 'Agencies', to: '/agency/list' },
            security: (auth) => auth.can({ action: 'create', model: 'agency' })
        }
    },
    {
        name: 'agencyView',
        path: '/agency/view/:agencyId',
        component: require('@/pages/AgencyView').default,
        props: (route) => ({
            agencyId: +route.params.agencyId,
        }),
        meta: {
            back: { label: 'Agencies', to: '/agency/list' },
            security: (auth) => auth.can({ action: 'view', model: 'agency', arg: +auth.to.params.agencyId })
        }
    },
    {
        name: 'agencyEdit',
        path: '/agency/edit/:agencyId',
        component: require('@/pages/AgencyEdit').default,
        props: (route) => ({
            agencyId: +route.params.agencyId,
        }),
        meta: {
            back: { label: ':agencyName', to: '/agency/view/:agencyId' },
            security: (auth) => auth.can({ action: 'edit', model: 'agency', arg: +auth.to.params.agencyId })
        }
    },
]
